import { useTranslation } from "react-i18next";

export const Model = () => {
  const { t } = useTranslation();

  const points = [
    {
      label: t("gestion.model.p1_label"),
      title: t("gestion.model.p1_title"),
      desc: t("gestion.model.p1_desc"),
      highlight: false,
    },
    {
      label: t("gestion.model.p3_label"),
      title: t("gestion.model.p3_title"),
      desc: t("gestion.model.p3_desc"),
      highlight: false,
    },
    {
      label: t("gestion.model.p4_label"),
      title: t("gestion.model.p4_title"),
      desc: t("gestion.model.p4_desc"),
      highlight: false,
    },
    {
      label: t("gestion.model.p2_label"),
      title: t("gestion.model.p2_title"),
      desc: t("gestion.model.p2_desc"),
      highlight: true,
    },
  ];

  return (
    <section data-testid="gestion-model" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Sticky title column */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                {t("gestion.model.kicker")}
              </p>
              <h2 className="mt-4 font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 leading-[1.05]">
                {t("gestion.model.title")}
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-slate-600 max-w-md">
                {t("gestion.model.subtitle")}
              </p>
            </div>
          </div>

          {/* Points list */}
          <div className="lg:col-span-7">
            <ul className="divide-y divide-slate-200 border-y border-slate-200">
              {points.map((p, i) => (
                <li
                  key={i}
                  data-testid={`model-point-${i}`}
                  className={`group/row relative grid grid-cols-[auto,1fr] gap-6 md:gap-10 py-8 md:py-10 transition-colors ${
                    p.highlight ? "bg-slate-50/40" : ""
                  }`}
                >
                  {/* Left: number */}
                  <div className="shrink-0">
                    <span
                      className={`font-heading text-3xl md:text-4xl font-bold tracking-tight ${
                        p.highlight
                          ? "adonis-gradient-text"
                          : "text-slate-300"
                      }`}
                    >
                      {p.label}
                    </span>
                  </div>

                  {/* Right: content */}
                  <div className="min-w-0">
                    <h3 className="font-heading text-xl md:text-2xl font-bold tracking-tight leading-tight text-slate-900">
                      {p.title}
                    </h3>
                    <p className="mt-4 text-sm md:text-base leading-relaxed text-slate-600">
                      {p.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Model;
